import isDuitangImage from './isDuitangImage';
import { _dtImageTrans } from './__inner/image/_dtImageTrans';
import { _transToWebp } from './__inner/image/_transToWebp';

/**
 * @description 将图片裁剪成指定宽度的高度自适应图片 如果浏览器支持webp，默认转成webp格式，转gif为静态图
 * @param url 要裁剪的图片地址
 * @param width 期望的图片宽度
 * @returns 裁剪后的图片地址
 */
const dtImageThumb = (url: string, width: number): string => {
  let ret = _dtImageTrans(url, true, width, false);
  if (isDuitangImage(ret)) {
    ret = ret.replace(/\.gif$/, '.gif_jpeg');
    ret = _transToWebp(ret);
  }
  return ret;
};

export default dtImageThumb;
